/**
 * Tag URL convention: `prefix:type:id` (e.g. `c:company:bmw`, `m:event:fraud`).
 * The 3-part shape is enforced — anything else returns `null`.
 */

export interface ParsedTag {
  prefix: string;
  type: string;
  id: string;
  /** Convenience: `${type}:${id}` */
  key: string;
}

export class TagUtils {
  static parse(tag: string | undefined | null): ParsedTag | null {
    if (!tag) return null;
    const parts = tag.split(':');
    if (parts.length !== 3) return null;
    const [prefix, type, id] = parts;
    return { prefix, type, id, key: `${type}:${id}` };
  }

  static isValid(tag: string | undefined | null): boolean {
    return TagUtils.parse(tag) !== null;
  }
}
